export default __webpack_public_path__ + "static/media/tiktok-icon.92984b52.svg";